/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/**
 * Geospatial dependencies.
 */

// Leaflet
import L from "leaflet";

// Geocoding controller
import "leaflet-control-geocoder/dist/Control.Geocoder.js";

// Geometry editor
import "@geoman-io/leaflet-geoman-free";

// Fullscreen
import "leaflet.fullscreen";

/**
 * Configurations
 */
L.Icon.Default.imagePath = "/static/icons/";
